import { useTranslation } from 'react-i18next';
import { ChatContextType, PropsData, EntityActionCard, ScriptProp } from '@packages/global';
import EntityChatPanel from './EntityChatPanel';

export interface PropsChatPanelProps {
  projectId: string;
  episodeScriptId: string;
  currentData?: PropsData | null;
  onApply?: (action: { type: 'create' | 'update' | 'delete'; prop?: ScriptProp; index?: number }) => void | Promise<void>;
}

export default function PropsChatPanel({ projectId, episodeScriptId, currentData, onApply }: PropsChatPanelProps) {
  const { t } = useTranslation('script');
  const handleApplyAction = async (action: EntityActionCard) => {
    if (!onApply) return;

    if (action.actionType === 'create') {
      await onApply({
        type: 'create',
        prop: { name: action.name, prompt: action.prompt || '', imageUrl: action.imageUrl }
      });
    } else if (action.actionType === 'update') {
      // 主数据源是 ProjectAsset，不依赖 currentData 的 index 查找
      // entityId 是 LLM 从上下文中回传的 ProjectAsset.id，用于精确定位
      await onApply({
        type: 'update',
        // LLM 修改了提示词，旧图片已不匹配，强制清空 imageUrl
        prop: { name: action.name, prompt: action.prompt || '', description: action.description, imageUrl: '', entityId: action.entityId } as any,
      });
    } else if (action.actionType === 'delete') {
      const name = action.name || action.entityId;
      if (name) {
        await onApply({ type: 'delete', prop: { name, prompt: '', entityId: action.entityId } as any });
      }
    }
  };

  return (
    <EntityChatPanel
      projectId={projectId}
      episodeScriptId={episodeScriptId}
      contextType={ChatContextType.SCRIPT_PROPS}
      entityName={t('props.name')}
      currentData={currentData ? { items: currentData.props } : null}
      onApplyAction={handleApplyAction}
    />
  );
}
